export default __webpack_public_path__ + "static/media/sent_email_icon.248547b7.svg";